import { useEffect, useRef, useState } from 'react';

export const ScanDiscountInput = ({ id, value, mode = 'percent', gross = 0, onModeChange, onChange, onValidityChange }) => {
  const euro = mode === 'euro';
  const format = n => euro ? Number(n || 0).toFixed(2).replace('.', ',') : String(n || 0);
  const [draft, setDraft] = useState(format(value));
  const focused = useRef(false);
  const pendingDraft = useRef(false);
  const previousMode = useRef(mode);
  const maximum = euro ? Math.abs(gross) : 100;
  const parsed = Number(draft.replace(',', '.'));
  const validValue = amount => Number.isFinite(amount) && amount >= 0 && amount <= maximum + 1e-9
    && (!euro || Math.abs(amount * 100 - Math.round(amount * 100)) < 1e-7);
  const valid = draft.trim() !== '' && validValue(parsed);
  useEffect(() => {
    const changedMode = previousMode.current !== mode;
    previousMode.current = mode;
    if (changedMode) pendingDraft.current = false;
    // A new scan may reorder rows/change their totals, but must not discard an invalid edit.
    if (pendingDraft.current) {
      if (draft.trim() && validValue(parsed)) {
        pendingDraft.current = false;
        onChange(parsed); // A larger quantity can make a previously excessive euro discount valid.
      }
      return;
    }
    if (!focused.current || changedMode) setDraft(euro ? Number(value || 0).toFixed(2).replace('.', ',') : String(value || 0));
    // Synchronize only external values/mode/limits, never on a keystroke or callback identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, mode, euro, maximum]);
  useEffect(() => { onValidityChange(`discount-${id}`, valid); }, [id, valid, onValidityChange]);
  return <div className="min-w-0">
    <label htmlFor={`scan-discount-${id}`} className="block xl:sr-only text-[11px] font-bold text-black uppercase mb-1" data-testid={`scan-label-discount-${id}`}>Korting</label>
    <div className="flex items-stretch min-w-0">
      <input id={`scan-discount-${id}`} type="text" inputMode="decimal" aria-label={euro ? 'Eurokorting per artikelregel' : 'Kortingspercentage'}
        value={draft} aria-invalid={!valid} onFocus={e => { focused.current = true; e.target.select(); }} onChange={e => {
          const raw = e.target.value.replace(/^0+(?=\d)/, ''); setDraft(raw); const amount = Number(raw.replace(',', '.'));
          pendingDraft.current = !raw.trim() || !validValue(amount);
          if (!pendingDraft.current) onChange(amount);
        }} onBlur={() => { focused.current = false; if (!draft.trim()) { pendingDraft.current = false; setDraft(format(0)); onChange(0); } else if (valid) { pendingDraft.current = false; setDraft(format(parsed)); onChange(parsed); } }}
        className="field-input w-full min-w-0 !h-9 !py-1 !px-2 !rounded-r-none text-right text-sm" data-testid={`korting-${id}`} />
      <select value={mode} onChange={e => onModeChange?.(e.target.value)} aria-label="Korting in procent of euro"
        className="h-9 w-11 shrink-0 border border-l-0 border-gray-300 rounded-r bg-gray-50 text-xs text-gray-700 focus:bg-blue-50"
        data-testid={`scan-discount-mode-${id}`}><option value="percent">%</option><option value="euro">€</option></select>
    </div>
    {euro && <span className="block text-[11px] text-gray-500 mt-1" data-testid={`scan-discount-basis-${id}`}>per regel</span>}
    {!valid && <span role="alert" className="block text-[11px] text-red-700 mt-1" data-testid={`scan-discount-error-${id}`}>{euro ? `Vul € 0–${maximum.toFixed(2).replace('.', ',')} in, maximaal 2 decimalen.` : 'Vul 0–100% in.'}</span>}
  </div>;
};